import Modal from "@modules/layout/modal";
import { useUI } from "@context/ui-managed-context";
import ConfirmChangeAddress from "@modules/layout/confirmAddressView";
import LoadingView from "@modules/layout/loadingView";
import VerifyPhoneNumberNotice from "@modules/layout/redesign/Modals/VerifyPhoneNumberNotice/VerifyPhoneNumberNotice";
import VerifyPhoneNumberExit from "@modules/layout/redesign/Modals/VerifyPhoneNumberExit/VerifyPhoneNumberExit";
import VerifyPhoneNumberSuccess from "@modules/layout/redesign/Modals/VerifyPhoneNumberSuccess/VerifyPhoneNumberSuccess";
import VerifyPhoneNumber from "@modules/layout/redesign/Modals/VerifyPhoneNumber/VerifyPhoneNumber";
import ChangePhoneNumberNotice from "@modules/layout/redesign/Modals/ChangePhoneNumberNotice/ChangePhoneNumberNotice";
import AddPhoneNumberNotice from "@modules/layout/redesign/Modals/AddPhoneNumberNotice/AddPhoneNumberNotice";
import VerifyPhoneNumberNoticeWithPhoneSuggestion from "@modules/layout/redesign/Modals/VerifyPhoneNumberNoticeWithPhoneSuggestion/VerifyPhoneNumberNoticeWithPhoneSuggestion";
import LoginView from "@modules/layout/LoginView";

interface Props { }

const ModalUI: React.FC<Props> = () => {
  const { displayModal, closeModal, modalView } = useUI();


  let modalContent;
  if (modalView.name === "LOGIN_VIEW") {
    modalContent = <LoginView setClose={() => closeModal()} />;
  } else if (modalView.name === "CONFIRM_ADDRESS_VIEW") {
    modalContent = <ConfirmChangeAddress setClose={() => closeModal()} />;
  } else if (modalView.name === "LOADING_VIEW") {
    modalContent = <LoadingView />;
  } else if (modalView.name === "VERIFY_PHONE_NUMBER_NOTICE") {
    modalContent = <VerifyPhoneNumberNotice />;
  } else if (modalView.name === "VERIFY_PHONE_NUMBER_EXIT") {
    modalContent = <VerifyPhoneNumberExit />;
  } else if (modalView.name === "VERIFY_PHONE_NUMBER_SUCCESS") {
    modalContent = <VerifyPhoneNumberSuccess />;
  } else if (modalView.name === "VERIFY_PHONE_NUMBER") {
    modalContent = <VerifyPhoneNumber />;
  } else if (modalView.name === "CHANGE_PHONE_NUMBER_NOTICE") {
    modalContent = <ChangePhoneNumberNotice />;
  } else if (modalView.name === "ADD_PHONE_NUMBER_NOTICE") {
    modalContent = <AddPhoneNumberNotice />;
  } else if (modalView.name === "VERIFY_PHONE_NUMBER_NOTICE_WITH_PHONE_SUGGESTION") {
    modalContent = <VerifyPhoneNumberNoticeWithPhoneSuggestion />;
  } else {
    modalContent = null;
  }


  const handelClose = () => {
    if (modalView.name === "LOGIN_VIEW") {
      modalView.args?.[0]?.()
      closeModal()
    }
    else {
      closeModal()
    }
  }


  return (
    <Modal onClose={() => handelClose()} open={displayModal} cancelable={modalView.cancelable}>
      {modalContent}
    </Modal>
  );
};
export default ModalUI;
